<template>
<div>
  <v-card outlined>
    <v-card-title>
      <div>
        <h5>{{ title }}</h5>
        <h6 class="text-muted">{{ description }}</h6>
      </div>
      <v-spacer></v-spacer>
      <slot name="filterAndAction"></slot>
    </v-card-title>
    <v-card-text>
      <b-table
          :items="erpOrders"
          :fields="erpOrdersHeaders"
          hover
          responsive
          :per-page="perPage"
          :busy="erpOrdersLoading"
          show-empty
          head-row-variant="info"
          table-variant="white"
      >
        <template #empty="scope">
          <h6 class="text-center my-5">
            {{ scope.loading ? "Lütfen Bekleyin" : noOrderMessage }}
          </h6>
        </template>
        <template #cell(process)="data">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  class="mx-1"
                  fab
                  text
                  x-small
                  color="primary darken-1"
                  v-bind="attrs"
                  v-on="on"
                  @click="openSiparisDetailDialog(data.item.orderNumber)"
              >
                <v-icon dark> mdi-text-box-search </v-icon>
              </v-btn>
            </template>
            <span>Sipariş Detay Görüntüle</span>
          </v-tooltip>
        </template>
        <template #table-busy>
          <div class="text-center">
            <b-spinner
                variant="primary"
                size="lg"
                label="Text Centered"
            ></b-spinner>
          </div>
        </template>
      </b-table>
    </v-card-text>
  </v-card>
  <OrderDetailsDialog
      :showDialog="orderDetailDialog"
      :orderNumber="orderNumber"
      :title="'Sipariş Detay'"
      @dialogChange="(e) => (orderDetailDialog = e)"
  ></OrderDetailsDialog>
</div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import OrderDetailsDialog from "@/components/orders/ERPOrders/dialogs/OrderDetailsDialog";

export default {
  components: {
    OrderDetailsDialog,
  },
  name: "Son10Siparis.vue",
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    perPage: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 1
    },
  },
  computed:{
    ...mapState("auth",["user"]),
    ...mapState("order", ["erpOrders", "erpOrdersHeaders", "erpOrdersLoading","noOrderMessage"]),
  },
  async mounted() {
    this.fetchErpOrders({
      params: {
        userId: this.user.UserId,
        pageNumber: this.currentPage,
        pageSize: this.perPage,
        ...(!(this.searchText === "" || this.searchText == null)) && {searchText: this.searchText },
        ...(this.user.RoleGroupId === "3") && {currentCode: this.user.userInfo.erpCode},
        ...(this.user.RoleGroupId === "2") && {salesPersonCode: this.user.SalesPersonCode}
      },
      body: {

      }
    })
  },
  data(){
    return {
      orderDetailDialog: false,
      orderDetailDialogData: null,
      orderNumber: null
    }
  },
  methods: {
    ...mapActions("order",["fetchErpOrders"]),
    openSiparisDetailDialog(orderNumber) {
      this.orderNumber = orderNumber;
      this.orderDetailDialog = true;
    },
  }
}
</script>

<style scoped>

</style>